import axios from 'axios';
import store from '../../store';

import { logoutUser } from '../../actions/user';
import { getUserCookieOrSendToLogin } from '../AuthService';

/** globally handle response errors from interceptor
 *
 * CASES
 *   * 401 Unauthorised errors wipe local auth and redirect to admin login
 *   * ALL other errors pass promise rejection on
 *
 * @param { Object } error httpResponse object from error interceptor
 *
 * @returns { Promise<Object> } promise rejection passing along httpResponse error.
 */
function handleResponse(response) {
  return response;
}

/** globally handle response errors from interceptor
 *
 * CASES
 *   * 401 Unauthorised errors wipe local auth and redirect to login
 *   * ALL other errors pass promise rejection on
 *
 * @param { Object } error httpResponse object from error interceptor
 *
 * @returns { Promise<Object> } promise rejection passing along httpResponse error.
 */
function handleError(error) {
  if(error.response && error.response.status === 401) {
    store.dispatch(logoutUser());
    getUserCookieOrSendToLogin();
  }
  return Promise.reject(error);
}

const instance = axios.create({});
instance.interceptors.response.use(handleResponse, handleError);

/** provide axios proxy for calling mysofology as a customer
 *
 * NB: for some reason axios is sharing default headers accross instances, this works around it
 *
 */

export default {
  get: (url, auth) => (auth === false) ?
  instance.get(url) :
  instance.get(url, { headers: { Authorization: `Bearer ${store.getState().user.Authorization}`}}),
  post: (url, body) => instance.post(url, body, { headers: { Authorization: `Bearer ${store.getState().user.Authorization}` } }),
  delete: (url, body) => (!body) ?
  instance.delete(url, { headers: { Authorization: `Bearer ${store.getState().user.Authorization}` } }) :
  instance.delete(url, {data: body}, { headers: {"Content-Type" : "application/json"}})
};



// WEBPACK FOOTER //
// ./src/services/dataSources/mySuxApi.js